import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import ScrollToTop from './ScrollToTop'
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { HashRouter as Router, Link, Route } from 'react-router-dom';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const iconStyle = {
  margin: 1
}

// 泥潭币转移登记服务的地址（sanguoproxy/sanguo-service.js，服务器端已做端口映射）
// 必须用 https：站点可经 https 访问，http 接口会被浏览器按混合内容拦截
const TRANSFER_API = 'https://service.mudwalker.cn/service';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  mainText: {
    margin: 10,
    fontSize: 20,
  }
}));

const Privacy = () => {

  // 敏感信息突出展示与游戏内 AgreementScene 保持一致：包含以下关键字的行
  // 整行加粗并放大字号（正文16→18，对应游戏内的13→15），颜色沿用本站醒目红。
  const SENSITIVE_KEYWORDS = ['姓名', '身份证件号码', 'OAID', 'IMEI', 'MAC 地址',
    '已安装应用列表', '设备标识', '实名认证', '支付订单', '充值消费', '传感器列表',
    '手机号码', '短信验证码'];

  const renderLine = (line, i) => {
    if (!line.trim()) return <div key={i} style={{ height: 16 }} />;
    const sensitive = SENSITIVE_KEYWORDS.some(k => line.includes(k));
    return sensitive
      ? <div key={i} style={{ fontSize: 18, fontWeight: 'bold', color: '#d32f2f', lineHeight: 1.8 }}>{line}</div>
      : <div key={i} style={{ fontSize: 16, lineHeight: 1.8 }}>{line}</div>;
  };

  const HEAD = [
    '',
    '《隐私政策》',
    '',
    '更新日期：2026年9月20日',
    '生效日期：2026年9月20日',
  ];

  const BODY = [
    '',
    '上海手心软件有限公司（以下简称"我们"）深知个人信息对您的重要性，我们将按照《中华人民共和国个人信息保护法》《网络安全法》《未成年人保护法》等法律法规的规定，保护您的个人信息及隐私安全。本隐私政策适用于我们通过本公司产品（包括但不限于本网站、"泥潭三国"及"泥潭伏魔传"游戏客户端，以下简称"本应用"）向您提供服务所收集的信息。请您在使用本应用前，仔细阅读并充分理解本政策的全部内容。一旦您同意本政策并使用本应用，即视为您已同意我们按照本政策处理您的个人信息。',
    '',
    '一、我们收集的信息',
    '1.1 账号信息：当您使用手机平台账号（如华为、荣耀、小米、vivo、OPPO 等厂商账号）或抖音平台账号登录游戏时，我们会收集您的账号标识和账号名称，用于生成您的游戏唯一标识。当您使用手机号码登录 vivo 平台账号时，我们还会收集您在登录界面主动输入的手机号码及短信验证码，仅用于 vivo 平台账号的登录验证与绑定。',
    '1.2 设备标识信息：当您通过华为、荣耀、小米、vivo、OPPO、抖音 等渠道账号登录游戏时，为完成账号登录认证、充值支付、实名认证与防沉迷核验、安全风控及统计分析等功能，本游戏集成的各渠道联运SDK（详见本政策第 7.4 条“第三方SDK目录”）会在您同意本政策后，收集您的设备标识符（包括 OAID（匿名设备标识符）、Android ID、IMEI（如适用））、设备型号、操作系统版本、屏幕分辨率、设备品牌、MAC 地址、已安装应用列表等信息，用于账号登录认证与安全校验。上述信息由相应联运SDK依据其隐私政策处理（隐私政策链接见第 7.4 条），本游戏不会将上述设备标识信息用于本条所述目的之外的其他用途。荣耀渠道包中的荣耀游戏服务SDK内置安全风控组件，会在您同意本政策后读取设备传感器列表，用于模拟器等运行环境风险识别，该操作不读取传感器的测量数据。各渠道包应用内包含开发调试用途的加速度传感器接口（React Native 框架组件），正式版本不启用该功能、不注册传感器监听，亦不采集任何传感器数据。',
    '1.3 实名认证信息：根据国家防沉迷相关规定，当您进行实名认证时，我们需要收集您的姓名、身份证件号码（属于个人敏感信息），用于核验您的真实身份、识别您的年龄并确定是否适用未成年人防沉迷限制。如您不提供前述信息，将无法登录或在使用本游戏时受到相应限制。',
    '1.4 充值消费信息：当您在本应用中充值或消费时，我们会收集您的充值订单号、充值金额、购买物品、对应游戏角色及支付时间（上述支付类信息属于个人敏感信息），用于完成交易、发放您购买的物品、账务核对及未来的账户维护验证。',
    '1.5 网络与安全信息：为保障服务安全运行、识别异常行为并防止作弊、外挂等破坏公平环境的行为，我们会收集您的 IP 地址、访问日期和时间、登录日志等信息。',
    '1.6 游戏数据：您的游戏角色信息、游戏进度等数据会存储在游戏服务器上。',
    '',
    '二、我们如何使用收集的信息',
    '2.1 为您提供游戏登录和身份验证服务。',
    '2.2 为您保存和同步游戏数据。',
    '2.3 为您提供游戏防沉迷实名认证服务，并依据您的年龄对未成年人游戏时间进行限制。',
    '2.4 处理您的充值与消费请求，发放您购买的虚拟物品，并完成账务结算。',
    '2.5 用于保障游戏安全，防止作弊、外挂及其他破坏游戏公平的行为。',
    '2.6 在法律法规允许的范围内，用于改进我们的产品和服务。',
    '',
    '三、信息的存储与保留',
    '3.1 我们在中华人民共和国境内收集和产生的个人信息，将存储在中国境内。',
    '3.2 您的账号信息存储在您的设备本地和游戏服务器上。',
    '3.3 我们仅在为实现服务目的所必需的合理期限内保留您的个人信息；超出该期限后，我们将对您的个人信息进行删除或匿名化处理，法律法规另有规定的除外。',
    '',
    '四、信息的安全',
    '4.1 我们采用数据加密、访问控制、网络隔离、安全审计等行业通行的技术手段和管理措施，保护您的个人信息安全，防止信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。',
    '4.2 尽管我们采取了上述合理可行的措施，但请您知悉，互联网环境并非百分之百安全。如不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知事件基本情况、可能的影响、已采取或将要采取的处置措施以及您可以采取的防范措施，并按要求向监管部门报告。',
    '',
    '五、您的权利',
    '5.1 您有权访问、查阅您的个人信息。',
    '5.2 您有权更正您的个人信息。',
    '5.3 在符合条件的情况下，您有权删除您的个人信息（如我们违反约定收集、使用信息，或您注销账号等）。',
    '5.4 您有权撤回您的授权同意。撤回同意不影响此前基于您授权而开展的信息处理。',
    '5.5 您有权注销您的账号；账号注销后，我们将按法律法规要求删除或匿名化处理您的个人信息。',
    '',
    '六、未成年人保护',
    '6.1 我们非常重视对未成年人个人信息（属于个人敏感信息）的保护。若您是未满 18 周岁的未成年人，请在您的监护人监护、指导下，并在取得监护人同意后，认真阅读并同意本政策，方可使用本应用。',
    '6.2 我们会根据《关于防止未成年人沉迷网络游戏的通知》《国家新闻出版署关于进一步严格管理 切实防止未成年人沉迷网络游戏的通知》等规定，对未成年人的游戏时长、游戏时段及充值消费进行限制。',
    '6.3 若您是未成年人的监护人，发现您所监护的未成年人未取得您同意而使用本应用或处理其个人信息，您可以通过本政策载明的方式联系我们，我们将在核实后及时处理。',
    '',
    '七、第三方共享',
    '为向您提供服务，我们会在以下情形下向第三方共享必要的信息：',
    '7.1 渠道账号服务：当您通过华为、荣耀、小米、vivo、OPPO 等手机平台账号或抖音平台账号登录游戏时，相应的渠道 SDK 提供方会处理您的账号登录与身份信息，其处理行为受该渠道的隐私政策约束。',
    '7.2 充值支付服务：当您在本网站发起充值或购买时，相应的支付服务提供方（如微信支付、支付宝及各手机平台支付通道）会处理您的订单与支付信息（属于个人敏感信息），用于完成交易。',
    '7.3 我们仅共享为实现服务所必需的信息，且要求接收方按照法律法规及本政策的约定处理您的个人信息。除上述情形外，我们不会将您的个人信息共享给其他第三方，除非事先获得您的同意，或法律法规另有规定。',
    '7.4 第三方SDK目录：本应用各渠道包内实际接入的第三方SDK如下（以对应渠道包内实际包含的为准）：',
    '（1）vivo联运SDK（vivoUnionSDK，vivo渠道包）',
    'SDK开发者：广东天宸网络科技有限公司',
    '使用目的：vivo账号登录（含手机号码登录）、实名认证、充值支付、安全风控与统计分析',
    '收集信息：手机号码（仅当您使用手机号登录时由您在登录界面主动输入）、设备标识（如OAID/Android ID）、MAC地址、已安装应用列表（软件列表）、设备信息、账号标识、订单与支付信息',
    '隐私政策链接：https://zhan.vivo.com.cn/gameactivity/wk210421b4f09680',
    '（2）华为游戏服务SDK（HMS Core，华为及鸿蒙渠道包）',
    'SDK开发者：华为软件技术有限公司',
    '使用目的：华为账号登录、实名认证、充值支付',
    '收集信息：设备标识（如OAID/Android ID）、设备信息、账号标识、订单与支付信息',
    '隐私政策链接：https://consumer.huawei.com/cn/privacy/privacy-policy/',
    '（3）荣耀游戏服务SDK（Honor Game Service SDK，荣耀渠道包）',
    'SDK开发者：荣耀终端有限公司',
    '使用目的：荣耀账号登录、实名认证、充值支付',
    '收集信息：设备标识（如OAID/Android ID）、设备信息、传感器列表（安全风控，用于模拟器等运行环境风险识别）、账号标识、订单与支付信息',
    '隐私政策链接：https://www.honor.com/cn/privacy/privacy-policy/',
    '（4）小米游戏联运SDK（MiOauth SDK，小米渠道包）',
    'SDK开发者：北京小米移动软件有限公司',
    '使用目的：小米账号登录、实名认证、充值支付',
    '收集信息：设备标识（如OAID/Android ID）、设备信息、账号标识、订单与支付信息',
    '隐私政策链接：https://privacy.mi.com/all/zh_CN/',
    '（5）OPPO合作游戏SDK（com.nearme.game.sdk，OPPO渠道包）',
    'SDK开发者：广东欢太科技有限公司',
    '使用目的：OPPO账号登录、实名认证、充值支付',
    '收集信息：设备标识（如OAID/Android ID）、设备信息、账号标识、订单与支付信息',
    '隐私政策链接：https://ie-activity-cn.heytapimage.com/ie-activity/staticActivity/kpmYVr/htmls/kpmYVr.html?bizType=ie&actId=10001811&c=0',
    '（6）OPPO PUSH 客户端SDK（com.heytap.msp，OPPO渠道包）',
    'SDK开发者：广东欢太科技有限公司',
    '使用目的：消息推送',
    '收集信息：设备标识（如OAID/Android ID）、设备信息、应用信息',
    '隐私政策链接：https://open.oppomobile.com/new/developmentDoc/info?id=11228',
    '（7）抖音游戏联运SDK（GBSDK，com.bytedance.ttgame，抖音渠道包）',
    'SDK开发者：北京抖音科技有限公司',
    '使用目的：数据归因、统计分析、内容分享',
    '收集信息：设备标识（如OAID/Android ID）、设备信息、应用信息',
    '隐私政策链接：https://sf1-cdn-tos.douyinstatic.com/obj/ies-hotsoon-draft/ttgame/b93a991b-5cd9-46f9-bf33-b142f7226d02.html',
    '（8）抖音开放SDK（OpenSDK，com.bytedance.sdk.open.douyin，抖音渠道包）',
    'SDK开发者：北京抖音科技有限公司',
    '使用目的：抖音账号授权登录',
    '收集信息：设备标识（如OAID/Android ID）、设备信息、账号标识',
    '隐私政策链接：https://sf1-cdn-tos.douyinstatic.com/obj/ies-hotsoon-draft/ttgame/b93a991b-5cd9-46f9-bf33-b142f7226d02.html',
    '（9）微信Open SDK（com.tencent.mm.opensdk，general/taptap/haoyou/抖音渠道包）',
    'SDK开发者：深圳市腾讯计算机系统有限公司',
    '使用目的：微信APP内支付',
    '收集信息：设备信息、网络信息、订单与支付信息',
    '隐私政策链接：https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJKLOrQwu0nb8',
    '',
    '八、Cookies 与同类技术',
    '8.1 本网站及游戏客户端不使用 Cookies 及同类技术（如 Web Beacon、Pixel 标签等）收集您的个人信息。',
    '',
    '九、隐私政策的更新',
    '9.1 我们可能会适时对本政策进行修订。当发生重大变更时，我们会在本应用内以弹窗、推送通知或网站公告等显著方式向您告知。',
    '9.2 未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们还会将本政策的旧版本存档，供您查阅。',
    '',
    '十、联系我们',
    '10.1 如您对本政策或个人信息保护有任何疑问、意见或建议，可通过以下方式与我们联系：',
    '邮箱：108992099@qq.com',
    '10.2 一般情况下，我们将在 15 个工作日内回复。如您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及市场监管等监管部门投诉或举报。',
  ];

  return <div style={{ padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ width: '100%' }}>
      {HEAD.map(renderLine)}
      {BODY.map(renderLine)}
    </div>
  </div>
}

const UserAgreement = () => {

  return <div style={{ padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <br />
    《用户协议》<br />
    <br />
    更新日期：2026年8月19日<br />
    <br />
    一、总则<br />
    1.1 本协议是您与上海手心软件有限公司（以下简称"我们"）之间关于使用本公司产品（包括但不限于本网站、"泥潭三国"及"泥潭伏魔传"游戏客户端，以下简称"本应用"）所订立的协议。经营者：上海手心软件有限公司；联系方式：108992099@qq.com。<br />
    1.2 您在使用本应用前，应当认真阅读并遵守本协议，特别是以加粗、下划线等方式突出提示的条款。一旦您同意本协议并使用本应用，即视为您已充分理解并同意本协议的全部内容。如您不同意本协议的任何内容，请勿使用本应用。<br />
    <br />
    二、账号注册与使用<br />
    2.1 您登录本游戏后，应遵守本游戏的账号使用规则。如果您通过第三方账号（如华为、荣耀、小米、vivo、OPPO 等手机平台账号）登录游戏，应同时遵守相应第三方账号的相关使用规则。<br />
    2.2 您应妥善保管账号信息，因您个人原因导致账号泄露所引起的一切损失由您自行承担。<br />
    2.3 您不得将账号转让、出售或出借给他人使用。<br />
    <br />
    三、用户行为规范<br />
    3.1 您在使用本应用时，必须遵守中华人民共和国相关法律法规。<br />
    3.2 您不得利用本应用从事任何违法违规活动，包括但不限于发布违法信息、侵犯他人知识产权等。<br />
    3.3 您不得对本应用进行反编译、反汇编、修改、破解、改编或试图绕过本应用的技术保护措施。<br />
    3.4 您不得使用任何外挂、插件、自动化脚本、加速器、模拟器多开工具或第三方工具对本应用进行干扰、破坏或获取不正当利益。<br />
    <br />
    四、虚拟物品与充值<br />
    4.1 本游戏内的"泥潭币"等虚拟物品为您在本应用中使用的虚拟数据，您可按本应用公布的规则购买并使用。除法律法规另有规定外，虚拟物品不能兑换为法定货币，也不能相互转让。<br />
    4.2 您在购买虚拟物品前，请确认您的购买内容。除法律法规另有规定或本协议另有约定外，虚拟物品一经购买，原则上不予退款。<br />
    4.3 如发生充值未到账、充值错误等情况，您可通过本协议载明的方式联系我们，我们将在核实后予以处理。<br />
    4.4 我们保留对虚拟物品的发放规则、价格、有效期等进行调整的权利，调整前将在本应用内予以公示。<br />
    <br />
    五、防沉迷与未成年人保护<br />
    5.1 根据国家关于防止未成年人沉迷网络游戏的相关规定，本游戏对未成年人的游戏时长、游戏时段及充值金额进行限制。<br />
    5.2 您在进行游戏前应配合完成实名认证。如您提供虚假身份信息，由此产生的一切后果由您自行承担。<br />
    5.3 若您是未成年人的监护人，请妥善保管您的支付设备、支付账户及密码，避免被监护人在未取得您同意的情况下进行充值消费。如发生未成年人未经监护人同意的充值，您可按相关规定及我们公示的退款流程申请处理。<br />
    <br />
    六、知识产权<br />
    6.1 本应用的所有内容（包括但不限于文字、图片、音频、视频、软件等）的知识产权均归我们或相关权利人所有。<br />
    6.2 未经我们书面许可，您不得以任何形式复制、传播、展示本应用的任何内容。<br />
    <br />
    七、免责声明<br />
    7.1 本应用按"现状"提供。在法律法规允许的范围内，对于因不可抗力、第三方原因、系统维护或故障、网络中断等非我们故意或重大过失导致的服务异常或数据损失，我们不承担赔偿责任。<br />
    7.2 您应自行妥善备份您的游戏数据。对于因您自身原因（如账号遗失、设备故障、未及时备份等）导致的数据损失，我们不承担责任。<br />
    <br />
    八、协议的变更<br />
    8.1 我们有权根据业务需要、法律法规变化等原因修改本协议内容。<br />
    8.2 对于重大变更，我们会在本应用内以网站公告、弹窗、推送通知等显著方式向您告知。修改后的协议自公布之日起生效；如您在变更后继续使用本应用，即视为您同意修改后的协议。如您不同意，您可以停止使用本应用。<br />
    <br />
    九、协议终止<br />
    9.1 如您违反本协议约定，我们有权根据情节轻重，对您采取警告、限制功能、暂停或终止服务等措施。<br />
    9.2 您有权随时停止使用本应用。<br />
    <br />
    十、争议解决与法律适用<br />
    10.1 本协议的订立、生效、解释、履行及争议解决均适用中华人民共和国大陆地区法律。<br />
    10.2 因本协议或本应用产生的争议，双方应首先友好协商解决；协商不成的，任何一方均可向我们住所地有管辖权的人民法院提起诉讼。<br />
  </div>
}

const Xiyou = () => {

  const classes = useStyles();
  const [select, setSelect] = React.useState(1);
  const [userid, setID] = React.useState('');
  const [open, setOpen] = React.useState(false);


  const isPC = () => {
    var userAgentInfo = navigator.userAgent;
    console.log(userAgentInfo)
    var Agents = ["Android", "iPhone",
      "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) >= 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  var isRunningOnPC = isPC();

  const showSample = () => {
    if (isRunningOnPC) {
      return <div>
        <img style={{ width: '15%', margin: 1 }} alt="" src={require("./2.png")} />
        <img style={{ width: '15%', margin: 1 }} alt="" src={require("./3.png")} />
        <img style={{ width: '15%', margin: 1 }} alt="" src={require("./4.png")} />
        <img style={{ width: '15%', margin: 1 }} alt="" src={require("./5.png")} />
      </div>

    }
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <IconButton
        style={iconStyle}
        edge="end"
        aria-label="back"
        aria-haspopup="true"
        onClick={() => {
          if (select > 1) setSelect(select - 1)
          else setSelect(5)

        }}
        color="inherit"
      >
        <ArrowBackIosIcon />
      </IconButton>
      <img style={{ width: '60%', margin: 1 }} alt="" src={require("./" + select + ".png")} />

      <IconButton
        style={iconStyle}
        edge="end"
        aria-label="forward"
        aria-haspopup="true"
        onClick={() => {
          if (select < 5) setSelect(select + 1)
          else setSelect(1)
        }} color="inherit"
      >
        <ArrowForwardIosIcon />
      </IconButton>

    </div>
  }

  const shareText = () => {

    return `
泥潭伏魔传 
经典的文字MUD游戏

Android端下载
http://www.palmmud.com/share.php?direct=android_download&sharedBy=${userid}

iOS端下载(App Store)
http://www.palmmud.com/share.php?direct=ios_download&sharedBy=${userid}

访问主页
http://www.palmmud.com/share.php?direct=home_page&sharedBy=${userid}
      `

  }

  const renderXiyou = () => {
    return <div style={{ color: '#212121' }}>

      <h3 style={{ color: 'cyan' }} id='page1'>简介</h3>
      《泥潭伏魔传》致力于让MUD这个网络游戏的原始人鼻祖重新焕发青春。<br /><br />
      《泥潭伏魔传》是根据当年风靡网络的文字MUD游戏改编而来的手机MUD网络游戏，游戏内没有任何的图片，完全以纯文字的方式，展现武功、法术、妖魔、神仙，修仙，求道的一个RPG游戏，如果你的想象力丰富，喜欢看修仙小说，且有耐心，那么这是一个适合你的游戏。
      <br /><br />
      相对于原始的MUD游戏，最大的变化是你不再需要输入或者记住任何指令，整个游戏完全可以使用点击完成。
      <br />
      下面是一些游戏内的截图(版本更新后可能略有不同) -
      <br />
      <br />

      <Divider light />
      <br />
      <br />
      {showSample()}
      <br />
      <br />
      <hr />

      <span>

        <h3 style={{ color: 'cyan' }} id='page2'>界面操作</h3>
        这里只简单介绍下场景界面。战斗界面和聊天界面玩家可以举一反三。<br /><br />
        <img alt="" src={require("./demo.jpg")} style={{ width: isRunningOnPC ? '40%' : '100%', height: 'auto', }} /><br /><br />


        <h3>方向键</h3>
        方向键根据所在位置会发生变化，点相应的键就会执行往该方向行动的指令。方向上面的小文字标注该方向的目标位置名称。<br />比如下面的方向里，点第一个西会前往朱雀大街。<br />

        <img alt="" src={require("./dirs.jpg")} style={{ width: isRunningOnPC ? '40%' : '100%', height: 'auto', marginRight: 5 }} /><br /><br />

        <h3>菜单键</h3>
        最下面有一排：【指令】【聊天】【帮助】【行囊】【宝盒】【飞行】<br />
        <img alt="" src={require("./menus.jpg")} style={{ width: isRunningOnPC ? '40%' : '100%', height: 'auto', }} /><br />

        <strong>1.    指令</strong><br /><br />
        指令里保存了游戏内可以执行的动作。玩家可以逐一尝试，除了账号删除 ^_^！<br />
        这些指令大多可以拖放到主界面或者战斗界面，通过长按主界面或者战斗界面的按键选择。
        <br /><br />
        <strong>2.     聊天</strong><br /><br />
        顾名思义。
        关于聊天界面的使用方式，玩家可以在游戏里查看聊天界面里的帮助。很简单。
        <br /><br />
        <strong style={{ color: 'red', bold: true }}>3.     帮助</strong><br />
        <p style={{ color: 'red' }}>
          游戏的内置帮助。<br />
          游戏里有非常详细的内置帮助，且保持更新。新人玩家请务必认真阅读。
        </p>

        <br />
        <strong>4.     行囊</strong><br /><br />
        就是其他游戏中的包裹，你身上带的东西都在这里面，可以直接点击里面的物品进行操作，月光宝盒也在这里面。<br />
        <br />
        <strong>5.     宝盒</strong><br /><br />
        本站特色之一，使用行囊里面的“月光宝盒”标记户外地点，然后点击宝盒就可以看到保存的地点，直接点击就进行传送，非常方便，但是只能在室外。<br /><br />
        <strong>6.     飞行</strong><br /><br />
        西游记的特色就是飞行，基本上大的场景都可以飞到的，多摸索吧。<br /><br />
        <strong>玩家导师</strong><br /><br />
        新人可以在游戏里找个玩家作为导师。导师会从你的成长中获益，而你无论是否有导师，收益都不受影响，因此是两全其美的好事。如果觉得导师未能很好的帮助自己，玩家可以随时解除自己的导师。
        <br />      <br />

      </span>
      <hr />

      <br />
      <h3 style={{ color: 'cyan' }} id='page3'>游戏下载</h3>

      <a href="http://palmmud-android.oss-cn-hangzhou.aliyuncs.com/palmmud-xyjclient.apk">点击下载Android最新版</a><br />

      二维码下载Android最新版(要求安卓版本5.0以上 微信内请使用[在浏览器]打开选项)<br />

      <img alt="" src={require("./android.jpg")} /><br />
      <br />
      <Divider light />
      <br /><br />
      <a href="https://itunes.apple.com/us/app/id913429015?l=zh&ls=1&mt=8">iOS最新版(AppStore)</a><br />

      二维码下载iOS最新版(AppStore)<br />
      <img alt="" src={require("./ios_appstore.jpg")} />
      <br /><br />
      西游讨论QQ群：524317606
      <br /><br />
    </div>
  }

  const iconStyle = {
    margin: 1
  }

  const scrollToAnchor = (anchorName) => {
    if (anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) { anchorElement.scrollIntoView(); }
    }
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={() => { setOpen(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p> 拷贝粘贴虚线以下文字至分享处</p>
            <div>----------------------------------</div>
            <div style={{ margin: 5, fontSize: 12 }}>
              <div>
                <div>泥潭伏魔传 经典的文字MUD游戏</div><br />
                <div>Android端下载</div>
                {'http://www.palmmud.com/share.php?direct=android_download&sharedBy=' + userid}
                <br />              <br />

                <div>iOS端下载(App Store)</div>
                {'http://www.palmmud.com/share.php?direct=ios_download&sharedBy=' + userid}
                <br />              <br />

                <div>访问主页</div>
                {'http://www.palmmud.com/share.php?direct=home_page&sharedBy=' + userid}
              </div>

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CopyToClipboard text={shareText()} onCopy={(text, result) => { setOpen(false) }}>
            <Button color="primary" autoFocus>
              拷贝至粘贴板
            </Button>
          </CopyToClipboard>

        </DialogActions>
      </Dialog>


      <div style={{ margin: 25, padding: 10, fontSize: 14, minHeight: 720 }}>
        <h2 style={{ color: 'black' }} id='page3'>泥潭伏魔传</h2>

        {renderXiyou()}
      </div>

    </div >
  );
}

const Payment = () => {

  const [userName, setName] = React.useState('');
  const [item, setItem] = React.useState('');
  const [payment, setPayment] = React.useState('');
  const [open, setOpen] = React.useState(false);

  return <div style={{ padding: 10 }}>
    <Dialog
      open={open}
      onClose={() => { setOpen(false) }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p> 拷贝粘贴虚线以下文字至分享处</p>
          <div>----------------------------------</div>
          <div style={{ margin: 5, fontSize: 12 }}>
            <div>

            </div>

          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" autoFocus onClick={() => {
          setOpen(false)
        }}>
          关闭
        </Button>

      </DialogActions>
    </Dialog>

    <h3 style={{ color: '#284CD4' }} id='page4'>游戏充值</h3>

    <form onSubmit={(evt) => { console.log('testing form') }} name='payment' target="_blank">
      商品名称: <strong>泥潭币</strong><br />
      商品描述: 玩家可以使用泥潭币在 泥潭三国 游戏内购买会员或其他物品。<br /><br />
      <hr /><br />

      <strong style={{ color: "#284CD4" }}>1） 选择购买项目</strong><br />
      <FormControl style={{ padding: 10 }}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          name="radio-buttons-group"
          onChange={(evt, value) => { setItem(value) }}
        >
          <FormControlLabel value="nitanbi30" control={<Radio />} label="30泥潭币 = 30元" />
          <FormControlLabel value="nitanbi100" control={<Radio />} label="100泥潭币   = 100元" />
          <FormControlLabel value="nitanbi200" control={<Radio />} label="200泥潭币   = 198元" />
          <FormControlLabel value="nitanbi600" control={<Radio />} label="600泥潭币   = 588元" />
          <FormControlLabel value="nitanbi2000" control={<Radio />} label="2000泥潭币   = 1920元" />

        </RadioGroup>
      </FormControl>
      <br />
      <strong style={{ color: "#284CD4" }}>2） 输入游戏内已创建的角色名</strong><br />

      <TextField
        label="角色名"
        style={{ marginTop: 10 }}
        id="filled-required"
        defaultValue=""
        onChange={(event) => { setName(event.target.value.toLocaleLowerCase()) }}
        variant="outlined"
      />
      <br /> <br />
      <strong style={{ color: "#284CD4" }}>3） 选择支付方式</strong>：<br />

      <FormControl style={{ padding: 10 }}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          name="radio-buttons-group"
          onChange={(evt, value) => { setPayment(value) }}
        >
          <FormControlLabel value="wechatpay" control={<Radio />} label="微信" />
          <FormControlLabel value="alipay" control={<Radio />} label="支付宝" />

        </RadioGroup>
      </FormControl>

      <br />
      <br />
      <div style={{ margin: 10, borderColor: "black", borderWidth: 1 }}>{item ? (
        userName ? (payment ? "请再次确认选择" : "！请选择支付方式") : "！请输入角色名"
      ) : "！请选择购买项目"}</div>

      <Button color="yellow" disabled={userName.length < 2 || userName.length > 16 || !item || !payment} size="large" variant="contained"
        onClick={() => {

        }}
        style={{ color: "#284CD4" }}>
        4）进入支付
      </Button>

      <br /><br />
      <br /> 如果您在支付过程中发生任何问题，请联系游戏管理员。<br /><br />
    </form>

  </div>
}

const Sanguo = () => {

  const [select, setSelect] = React.useState(1);

  const isPC = () => {
    var userAgentInfo = navigator.userAgent;
    console.log(userAgentInfo)
    var Agents = ["Android", "iPhone",
      "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) >= 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  var isRunningOnPC = isPC();

  const showSample = () => {
    if (isRunningOnPC) {
      return <div>
        <img style={{ width: '20%', margin: 5 }} alt="" src={require("./sanguo-1.png")} />
        <img style={{ width: '20%', margin: 5 }} alt="" src={require("./sanguo-2.png")} />
        <img style={{ width: '20%', margin: 5 }} alt="" src={require("./sanguo-3.png")} /><br />
        <img style={{ width: '20%', margin: 5 }} alt="" src={require("./sanguo-4.png")} />
        <img style={{ width: '20%', margin: 5 }} alt="" src={require("./sanguo-5.png")} />
        <img style={{ width: '20%', margin: 5 }} alt="" src={require("./sanguo-6.png")} />
      </div>

    }
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <IconButton
        style={iconStyle}
        edge="end"
        aria-label="back"
        aria-haspopup="true"
        onClick={() => {
          if (select > 1) setSelect(select - 1)
          else setSelect(6)

        }}
        color="inherit"
      >
        <ArrowBackIosIcon />
      </IconButton>
      <img style={{ width: '60%', margin: 1 }} alt="" src={require("./sanguo-" + select + ".png")} />

      <IconButton
        style={iconStyle}
        edge="end"
        aria-label="forward"
        aria-haspopup="true"
        onClick={() => {
          if (select < 6) setSelect(select + 1)
          else setSelect(1)
        }} color="inherit"
      >
        <ArrowForwardIosIcon />
      </IconButton>

    </div>
  }

  return <div style={{ margin: 15, fontSize: 14, padding: 20 }}>
    <div>
      <h2 style={{ color: 'black' }} id='page3'>泥潭行者 - 三国</h2>

      <h3 style={{ color: 'cyan' }}>简介</h3>
      <p >

        泥潭行者-三国 是使用【泥潭行者开发平台】开发的新型MUD游戏。<br />游戏以三国演义根据玩家选择的阵营，分魏蜀吴三个剧情路线推进。

        经过各自不同的剧情任务后，从《三江口之战》开始，进入混战区。最后进入《三足鼎立》相互攻伐时期。<br />

        玩家可以通过右上角竖写的地名按键随时查看章节帮助。<br />
      </p>

      <h3 style={{ color: 'cyan' }}>游戏截图</h3>

      {showSample()}

      <h3 style={{ color: 'cyan' }}>基础知识</h3>



      <p >
        <strong>- 时间</strong><br />
        游戏内时间与现实中的时间有固定的对应关系。<br />

        游戏内一季度 = 现实中一天。也就是游戏自服务器启动时间开始，每24小时会过一个季节。<br />
        游戏内一天/十二时辰 = 现实中15分钟。玩家的部队游戏中的每天需进食两次。<br />

        子时 ：对应现代时间23点至第二天凌晨1点。以次类推。<br />
        丑时 ： 1点—— 3点<br />
        寅时 ： 3点—— 5点<br />
        卯时 ： 5点—— 7点 | 平明时分 <br />
        辰时 ： 7点—— 9点<br />
        巳时 ： 9点——11点<br />
        午时 ：11点——13点<br />
        未时 ：13点——15点<br />
        申时 ：15点——17点<br />
        酉时 ：17点——19点<br />
        戌时 ：19点——21点 | 初更时分 <br />
        亥时 ：21点——23点<br />
      </p>

      <p >
        <strong>- 属性</strong><br />

        游戏中玩家、部将以及装备、马匹等有各种不同属性。<br />

        部队的平均属性：<br />

        平均武力：增加部队普通攻击的伤害。<br />
        平均统御：提高部队攻击频率。<br />
        平均谋略：提高部队识破特别技能的概率。<br />

        单个武将的属性：<br />
        武力：单挑时增大单挑胜率，特别技能的伤害。<br />
        统御：某些特别技能的伤害和成功率。<br />
        谋略：某些特别技能的伤害和成功率。<br />

        活力：<br />
        活力充沛是玩家或者武将发动技能的必备条件。玩家要求40以上，武将要求70以上。弓（副手），单手剑，羽扇，马匹等可增加活力恢复速度。<br />
        此外，谋略型武将每回合恢复的基本活力约是武力型武将的两倍。
        <br />
      </p>

      <h3 style={{ color: 'cyan' }}>战争入门</h3>
      <p >
        <strong>- 兵种设定</strong><br />

        游戏中有三种不同兵种: 步兵、弓兵、骑兵。<br />

        玩家可在安全区内调整部队各兵种比例，调整时部队必须处于满编制状态。<br />

        以步兵对步兵的伤害为基本伤害计算：<br />
        - 骑兵对步兵，弓兵的基本伤害提高30%。<br />
        - 弓兵对骑兵伤害提高30%。<br />
        - 步兵对弓兵伤害提高20%。步兵对骑兵伤害降低20%。<br />
        - 兵种的攻击力会受到地形影响。<br />
        弓兵在城墙和城门的攻击力提高。<br />
        骑兵在山地、树林攻击力降低。<br />
        骑兵在水上攻击力大幅降低。<br />
        步兵在水上攻击力降低。<br />

        全部兵种的攻击力都会受到天气或时间影响（比如夜晚或者雪天），详细的影响请参考帮助 『战争入门』的 『天时地利』章节。<br /><br />

        三个兵种各自可以升级，每次升级，会获得额外10%的攻击和防御提高。<br />
        升级需要相应的印绶。印绶在达到一定级别后，可使用并提升兵种等级。<br />
        <br />
        步兵升级路线：<br />
        短刀兵 - 长枪兵 - 铁甲兵 - 虎卫军<br /><br />

        弓兵升级路线：<br />
        短弓手 - 强弓手 - 弩兵 - 连弩兵<br /><br />

        骑兵升级路线：<br />
        轻骑兵 - 重骑兵 - 枪骑兵 - 虎豹骑<br /><br />
      </p>


    </div>
    <hr />
    <div style={{ color: '#0091ea', marginTop: 20 }}>
      泥潭三国 客户端下载
    </div>

    <div style={{ margin: 15, fontSize: 14 }}>

      <a href='https://www.mudwalker.cn/invite.php?code=GHJYDY'>点击下载（安卓/iOS/鸿蒙 通用）</a> <br /><br />

      三国讨论QQ群：984648387
      <br />
      <br />

      <div style={{ fontSize: 14 }}>
      </div>

    </div>

  </div>
}

export default function PrimarySearchAppBar() {

  const isPC = () => {
    var userAgentInfo = navigator.userAgent;
    console.log(userAgentInfo)
    var Agents = ["Android", "iPhone",
      "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) >= 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  var isRunningOnPC = isPC();

  const renderMobile = () => {
    return (<div>
      <div style={{ color: '#0091ea', marginBottom: 10 }}>
        低耦合整体设计
      </div>

      <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>

        - 游戏驱动 <br />
        <div style={{ fontSize: 13, margin: 5, padding: 5 }}>
          - 异步单线程<br />
          - 世界/地图载入<br />
          - 游戏代码执行<br />
          - 登录/注册服务<br />
          - 数据库/日志服务<br />
          - 频道/聊天服务<br />
          - 新闻/邮件服务<br />
          - 内置帮助服务<br />
          - 拍卖/寄售服务<br />
          - 定时服务<br />
          - 更新服务<br />
          - ... ...<br />
        </div>

      </div>
      <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>
        - 游戏内容 <br />
        <div style={{ fontSize: 13, margin: 5, padding: 5 }}>
          - 房间/人物/物品<br />
          - 战斗<br />
          - 经验奖励等级<br />
          - 游戏专有基类/服务/设定<br />
          - ... ...<br />
        </div>
      </div>
      <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>

        - 世界编辑器 <br />
        <div style={{ fontSize: 13, margin: 5, padding: 5 }}>
          - 跨平台(Win/Mac/Linux)<br />
          - 本地/Git-based<br />
          - 快速的地图、人物开发<br />
          - 便捷定位，编码<br />
          - 支持独立编辑器<br />
          - Json-based<br />
          - ... ...<br />
        </div>

      </div>
      <div style={{ margin: 5, fontSize: 13 }}>
        示例视频 (泥潭行者 - 三国)
      </div>
      <video src={require('./mudwalker.mp4')} style={{ width: isRunningOnPC ? '65%' : '80%', height: isRunningOnPC ? '80%' : undefined, margin: 20, borderWidth: 2, borderColor: '#0091ea', borderStyle: 'solid' }} controls="controls"></video>

      <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>

        - 客户端 <br />
        <div style={{ fontSize: 13, margin: 5, padding: 5 }}>
          - 跨平台(iOS/Android)<br />
        </div>

      </div>
      <div style={{ margin: 5, fontSize: 13 }}>
        示例视频 (泥潭行者 - 三国)
      </div>
      <div>
        <video src={require('./sanguo.mp4')} controls="controls" style={{ alignItems: 'center', justifyContent: 'center', width: isRunningOnPC ? '25%' : '50%', height: '80%', margin: 20, borderWidth: 2, borderColor: '#0091ea', borderStyle: 'solid' }}></video>

      </div >
    </div>
    )
  }
  const renderPC = () => {
    return (<div>
      <div style={{ color: '#0091ea', marginBottom: 10 }}>
        低耦合整体设计
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>

          - 游戏驱动 <br />
          <div style={{ fontSize: 13, margin: 2, padding: 5 }}>
            - 异步单线程<br />
            - 世界/地图载入<br />
            - 游戏代码执行<br />
            - 登录/注册服务<br />
            - 数据库/日志服务<br />
            - 频道/聊天服务<br />
            - 新闻/邮件服务<br />
            - 内置帮助服务<br />
            - 拍卖/寄售服务<br />
            - 定时服务<br />
            - 更新服务<br />
            - ... ...<br />
          </div>

        </div>
        <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>
          - 游戏内容 <br />
          <div style={{ fontSize: 13, margin: 2, padding: 5 }}>
            - 房间/人物/物品<br />
            - 战斗<br />
            - 经验奖励等级<br />
            - 游戏专有基类/服务/设定<br />
            - ... ...<br />
          </div>
        </div>
        <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>

          - 世界编辑器 <br />
          <div style={{ fontSize: 13, margin: 2, padding: 5 }}>
            - 跨平台(Win/Mac/Linux)<br />
            - 本地/Git-based<br />
            - 快速的地图、人物开发<br />
            - 便捷定位，编码<br />
            - 支持独立编辑器<br />
            - Json-based<br />
            - ... ...<br />
          </div>

        </div>

        <div style={{ width: isRunningOnPC ? '30%' : '80%' }}>

          - 客户端 <br />
          <div style={{ fontSize: 13, margin: 5, padding: 5 }}>
            - 跨平台(iOS/Android)<br />
          </div>

        </div>

      </div>
      <div style={{ color: '#0091ea' }}>
        世界编辑器示例 (泥潭行者 - 三国)
      </div>
      <video src={require('./mudwalker.mp4')} style={{ width: isRunningOnPC ? '65%' : '80%', height: isRunningOnPC ? '80%' : undefined, margin: 20, borderWidth: 2, borderColor: '#0091ea', borderStyle: 'solid' }} controls="controls"></video>
      <div style={{ color: '#0091ea' }}>
        对应以上的客户端效果 (泥潭行者 - 三国)
      </div>
      <div>
        <video src={require('./sanguo.mp4')} controls="controls" style={{ alignItems: 'center', justifyContent: 'center', width: isRunningOnPC ? '25%' : '50%', height: '80%', margin: 20, borderWidth: 2, borderColor: '#0091ea', borderStyle: 'solid' }}></video>

      </div >
    </div>
    )
  }

  // 泥潭币累计值转移登记：营火服角色 → 旌旗服角色（直接数据库操作，见 sanguoproxy/service-transfer.js）
  const Transfer = () => {

    const [fromUUID, setFromUUID] = React.useState('');
    const [fromID, setFromID] = React.useState('');
    const [fromName, setFromName] = React.useState('');
    const [toUUID, setToUUID] = React.useState('');
    const [toName, setToName] = React.useState('');
    const [info, setInfo] = React.useState(null);
    const [hint, setHint] = React.useState('');

    const postTransfer = (path, onOk) => {
      let bodyData = JSON.stringify({ fromUUID, fromID, fromName, toUUID, toName });

      fetch(TRANSFER_API + path, {
        method: 'post',
        body: bodyData,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return response.json();
      })
        .then(data => {
          console.log(data)
          if (data.msg) {
            setInfo(null)
            setHint(data.msg)
          }
          else {
            onOk(data)
          }
        })
        .catch(error => {
          console.error(error)
          setHint('连接服务器失败，请稍后再试')
        });
    }

    const validInput = () => {
      if (fromUUID.length !== 36) {
        alert('营火服识别码不能为空，且长度为36位')
        return false;
      }
      if (!/^\d{17}[\dXx]$/.test(fromID)) {
        alert('身份证号码格式错误')
        return false;
      }
      if (fromName.length < 1 || fromName.length > 5) {
        alert('营火服角色名需为1-5个字符')
        return false;
      }
      if (toUUID.length !== 36) {
        alert('旌旗服识别码不能为空，且长度为36位')
        return false;
      }
      if (toName.length < 1 || toName.length > 5) {
        alert('旌旗服角色名需为1-5个字符')
        return false;
      }
      return true;
    }

    const doCheck = () => {
      if (!validInput()) return;
      setHint('查询中...')
      postTransfer('/transfer/check', (data) => {
        setHint('')
        setInfo(data)
      })
    }

    const doTransfer = () => {
      if (!validInput()) return;
      setInfo(null)
      setHint('提交中...')
      postTransfer('/transfer/do', (data) => {
        setHint(data.msg)
        alert(data.msg)
      })
    }

    return (<div style={{ minHeight: 720, padding: 30 }}>

      <div>
        <h3>营火老兵征战旌旗服福利</h3>
        <hr />

        <strong>1，会员等级继承：</strong>
        <div>玩家可以转移自己在营火服的充值总额给旌旗服的新角色，旌旗服角色可全额继承该充值总额用于计算自己的会员等级。</div>
        <br />
        <div><strong style={{ color: '#d32f2f' }}>** 新服和老服必须都是用完全相同身份证号码实名登记的角色之间才能转移！每个营火服角色仅能转移一次。</strong></div>
        <div><strong style={{ color: '#d32f2f' }}>** 在新服的角色必须是官服包(官网下载或者游戏官方群里下载或者是AppleStore下载，有实名登记页面)不能是渠道包（渠道包实名认证由渠道完成无法对比）。</strong></div>
        <div><strong style={{ color: '#d32f2f' }}>** 当有多个角色要转移时，请所有转移完毕后再登录旌旗服角色。</strong></div>
        <div>** 旌旗服角色登录时，按记录的转移总数额计算会员等级并一次性领取相应奖励。之后再转移的充值额，可以计算入会员等级但是不会再有奖励。</div>
        <div>** 该网址开放2周后关闭。2周后再有回坑的老玩家，请联系五月。</div>
        <div>** 请仔细核对旌旗服识别码和角色名，登记到错误角色上无法撤回。</div>
        <br />

        <TextField
          style={{ width: '60%' }}
          label="营火服识别码(注意大小写相关)"
          id="filled-required"

          defaultValue=""
          onChange={(event) => { setFromUUID(event.target.value.toLocaleLowerCase().trim()) }}
          variant="outlined"
        />
        <br /><br />
        <TextField
          style={{ width: '60%' }}
          label="身份证号码（须与营火服识别码实名信息一致）"
          id="filled-required2"

          defaultValue=""
          onChange={(event) => { setFromID(event.target.value.trim()) }}
          variant="outlined"
        />
        <br /><br />
        <TextField
          style={{ width: '60%' }}
          label="营火服角色名"
          id="filled-required3"

          defaultValue=""
          onChange={(event) => { setFromName(event.target.value.trim()) }}
          variant="outlined"
        />
        <br /><br />
        <TextField
          style={{ width: '60%' }}
          label="旌旗服识别码(注意大小写相关)"
          id="filled-required4"

          defaultValue=""
          onChange={(event) => { setToUUID(event.target.value.toLocaleLowerCase().trim()) }}
          variant="outlined"
        />
        <br /><br />
        <TextField
          style={{ width: '60%' }}
          label="旌旗服角色名"
          id="filled-required5"

          defaultValue=""
          onChange={(event) => { setToName(event.target.value.trim()) }}
          variant="outlined"
        />
        <Button
          style={{ margin: 15 }}
          color="primary" variant="contained" onClick={() => { doCheck() }}>
          查询
        </Button>
      </div>

      <hr></hr>

      {info
        ? <div>
          <div style={{ margin: 15 }}>{'营火服角色: ' + info.fromName}</div>
          <div style={{ margin: 15 }}>{'泥潭币累计值: ' + info.nitanbiTotal}</div>
          <div style={{ margin: 15 }}>{'转移至旌旗服角色: ' + info.toName}</div>
          <div style={{ margin: 15 }}>
            <Button
              color="primary" variant="contained" onClick={() => { doTransfer() }}>
              确认登记转移
            </Button>
          </div>
        </div>
        : <div style={{ margin: 15 }}>{hint}</div>
      }

      <br />
      <strong>2，道具奖励：</strong>
      <br /><br />
      <div>根据继承的会员等级，给予在旌旗服角色以下道具奖励：</div>
      <div>- 任意充值记录都会获得【营火徽章】，作为在营火服战斗过的老兵留念。</div>
      <br />
      <div>会员等级0，继承充值总额[30,200)，玩家在旌旗服可获得：</div>
      <div>- 30天会员</div>
      <br />
      <div>会员等级1，继承充值总额[200,1000)，玩家在旌旗服可获得：</div>
      <div>- 60天会员</div>
      <div>- 武将之书*2</div>
      <div>- 豪杰之书*2</div>
      <div>- 木牛流马4个</div>
      <br />
      <div>会员等级2，继承充值总额[1000,5000)，玩家在旌旗服可获得：</div>
      <div>- 90天会员</div>
      <div>- 武将之书*4</div>
      <div>- 豪杰之书*4</div>
      <div>- 征召豪杰之书*2</div>
      <div>- 木牛流马8个</div>
      <br />
      <div>会员等级3，继承充值总额[5000,20000)，玩家在旌旗服可获得：</div>
      <div>- 180天会员</div>
      <div>- 豪杰之书*4</div>
      <div>- 征召豪杰之书*4</div>
      <div>- 英杰之书*2</div>
      <div>- 木牛流马12个</div>
      <br />
      <div>会员等级4，继承充值总额20000及以上，玩家在旌旗服可获得：</div>
      <div>- 180天会员</div>
      <div>- 豪杰之书*4</div>
      <div>- 英杰之书*4</div>
      <div>- 征召英杰之书*2</div>
      <div>- 木牛流马12个</div>
      <br />

    </div>)
  }

  const Home = () => {

    return (
      <div >
        <div style={{ maring: 20, padding: 20 }}>
          <div style={{ color: '#0091ea' }}>
            现代MUD文字游戏开发架构
          </div>
          <div style={{ fontSize: 14, padding: 5 }}>
            - EcmaScript 6<br />
            - Node.js <br />
            - React.js<br />
            - Mobx.js<br />
            - Material UI<br />
            - Electron<br />
            - React Native<br />

          </div>
          <div style={{ fontSize: 14, color: 'gray' }}>
            ✔ 全JavaScript开发技术栈
          </div>
          <hr />
          {isRunningOnPC ? renderPC() : renderMobile()}
          <hr />

          <div style={{ color: '#0091ea' }}>
            泥潭三国 客户端下载
          </div>
          <Link to="/Sanguo">进入泥潭三国专题</Link>

          <div style={{ margin: 15, fontSize: 14 }}>
            <a href='https://www.mudwalker.cn/invite.php?code=GHJYDY'>点击下载（安卓/iOS/鸿蒙 通用）</a> <br /><br />
            泥潭三国QQ群：984648387
            <br />
          </div>
          <hr />
          <div style={{ color: '#0091ea' }}>
            联系我们
          </div>
          <div style={{ margin: 10, fontSize: 14 }}>
            - QQ: 108992099<br />
            - Email: 108992099@qq.com
          </div>
        </div>

      </div>
    );
  }

  return (
    <Router>

      <AppBar position="static">
        <Toolbar>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div>
              <div style={{ marginTop: 20, fontSize: 32 }}>
                泥潭行者
              </div>
              <div style={{ marginLeft: 5, marginBottom: 5 }}>
                - 往梦想之地
              </div>
              <div style={{ marginLeft: 5, marginBottom: 5, display: 'flex', flexDirection: 'column', flexGrow: 'stretch', fontSize: 13 }}>
                <Link to="/" style={{ color: 'white' }}>泥潭行者平台</Link>
                <Link to="/Sanguo" style={{ color: 'white' }}>泥潭三国</Link>
                <Link to="/Xiyou" style={{ color: 'white' }}>泥潭伏魔传</Link>

              </div>
            </div>

          </div>


        </Toolbar>
      </AppBar>
      <div className="App">
        <ScrollToTop>

          <Route path="/" exact component={Home}></Route>
          <Route path="/Sanguo" component={Sanguo}></Route>
          <Route path="/Xiyou" component={Xiyou}></Route>
          <Route path="/Payment" component={Payment}></Route>
          <Route path="/Privacy" component={Privacy}></Route>
          <Route path="/UserAgreement" component={UserAgreement}></Route>
          <Route path="/Transfer" component={Transfer}></Route>

        </ScrollToTop>

      </div>
      <hr />

      <footer style={{ textAlign: 'left', fontSize: 12, bold: true, marginLeft: 20, color: 'gray' }}>
        © 2023 上海手心软件有限公司 版权所有<br /><br />

        抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当<br />
        适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活<br />
        适龄提示语：本网站所有游戏适合18岁以上用户<br /><br />

        <a href="http://beian.miit.gov.cn">沪ICP备13026401号-4</a> <br />
        <a href="http://beian.miit.gov.cn">沪B2-20170186</a>

        <div >

          <img alt='' src={require("./beian.png")} />
          <a target="_blank" rel="noopener noreferrer" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502003281">
            <span >沪公网安备 31010502003281号</span></a>
        </div>
        <Link to="/Privacy">隐私政策</Link>
        &nbsp;|&nbsp;
        <Link to="/UserAgreement">用户协议</Link>

        <br />        <br />
        <br />

      </footer>
    </Router>
  );

}